import { Avatar, Button, Divider, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react'
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SquareIcon from '@mui/icons-material/Square';
import { useState } from 'react';
import ImageDialog from '../Components/ImageDialog';
import ColorDialog from '../Components/ColorDialog';
import { getDefultItemImage } from '../../../../assets/DefultItemImage';
import { getHexColor } from '../../../hepler';

import APIErorr from '../../../Components/APIErorr';


import 'react-image-crop/dist/ReactCrop.css'
import { useDispatch, useSelector } from 'react-redux';
import { addEditCategorySettings, reset as restAddEditCategorySettings } from '../../../../redux/slice/Settings/Category/addEditCategorySettingSlices';
import Progress from '../../../Components/Progress';
import SuccessMsg from '../../../Components/SuccessMsg';

import { t } from 'i18next';






const getAvatar = (color, name, image, isCategory) => {



    if (color === 0) {

        if (isCategory) {

            return <Avatar variant={isCategory ? 'circular' : 'square'} alt={name} src={`data:image/jpeg;base64,${image}`} sx={{ width: isCategory ? 25 : 150, height: isCategory ? 25 : 100 }} />

        }

        return <img alt={name} src={`data:image/jpeg;base64,${image}`} style={{ width: isCategory ? 25 : 150, height: isCategory ? 25 : 100 }} />


    }


    if (color !== null) {



        return <Avatar variant={isCategory ? 'circular' : 'square'} alt={name} sx={{ width: isCategory ? 25 : 150, height: isCategory ? 25 : 100, bgcolor: getHexColor(color), marginLeft: isCategory && 1, marginRight: isCategory && 1 }} > </Avatar>


    }

    return <Avatar variant={isCategory ? 'circular' : 'square'} alt={name} sx={{ width: isCategory ? 25 : 150, height: isCategory ? 25 : 100, bgcolor: "rgb(231, 67, 182)", marginLeft: 1, marginRight: 1 }}  > <SquareIcon /> </Avatar>


}



function AddEditCategory(props) {

    const [setsaveCategoryFun, handleClose] = props.control || [null, null];
    const categoryData = props.Category
    const [searchParams] = useSearchParams();
    const [showsuccessMsg, setShowsuccessMsg] = useState(false);

    const shopId = searchParams.get("ShopId")
    const [showAlertMsg, setShowAlertMsg] = useState({

        textName: false
    })

    const navigate = useNavigate();

    const dispatch = useDispatch()
    const addEditCategorySettingReduser = useSelector((state) => state.addEditCategorySettingReduser);



    const [openImageDialog, setOpenImageDialog] = useState(false)
    const [openColorDialog, setOpenColorDialog] = useState(false)

    const [categorObject, setCategorObject] = useState(categoryData === null ?

        {
            "id": 0,
            "name": "",
            "tybe": null,
            "image": "",
            "color": -11419154,

        } : categoryData


    )






    const handelSaveCategory = () => async (dispatch) => {

        if (categorObject.name === '') {
            setShowAlertMsg({ ...showAlertMsg, textName: true })


            return;
        }


        setShowsuccessMsg(false)
       await dispatch(addEditCategorySettings({ shopId, categorObject }))


    }






  

    useEffect(() => {



        if (addEditCategorySettingReduser.loading === "succeeded") {
            if (categorObject.id !== 0) {


                if (handleClose !== null) {
                    handleClose(true)

                } else {
                    //// for mobile window size save back to item page

                    handelCancelButton();


                }



            } else {




                setShowsuccessMsg(true)

                setCategorObject({

                    "id": 0,
                    "name": "",
                    "tybe": null,
                    "image": "",
                    "color": -11419154,

                })







            }

             dispatch(restAddEditCategorySettings())


        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addEditCategorySettingReduser])















    useEffect(() => {
        ///For desktop window size only

        if (setsaveCategoryFun != null) {

            setsaveCategoryFun(() => () => dispatch(handelSaveCategory()))

        }


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categorObject, setsaveCategoryFun])





    ///For Mobile window size only
    const handelSaveButton = () => {
        dispatch(handelSaveCategory());


    }


    ///For Mobile window size only

    const handelCancelButton = () => {
        navigate({

            pathname: "/Dashboard/Settings/Category",
            search: "?" + searchParams.toString()


        })

    }





    const onChangePicture = e => {
        if (e.target.files[0]) {
            const reader = new FileReader();
            reader.addEventListener("load", () => {
                setCategorObject({ ...categorObject, color: 0, imageTemp: reader.result });

                setOpenImageDialog(true);


            });



            reader.readAsDataURL(e.target.files[0]);
        }
    };
    const handleChange = (event) => {

        let value = event.target.value;






        if (event.target.name === "buttons-group-imageType") {


            if (value === 'color') {

                setCategorObject({ ...categorObject, color: categorObject.color === 0 ? -11419154 : categorObject.color });



            } else {


                setCategorObject({ ...categorObject, color: 0, image: categorObject.image === '' || categorObject.image === null ? getDefultItemImage : categorObject.image });


            }


            return
        }

        if (event.target.name === "name" && value !== '') {

            setShowAlertMsg({ ...showAlertMsg, textName: false })


        }




        setCategorObject({ ...categorObject, [event.target.name]: value });


    };




    return (
        <Box component='form' sx={{ margin: setsaveCategoryFun === null && 2 }}>


            {showsuccessMsg && <SuccessMsg msg={t("MSG3")} />}

            {addEditCategorySettingReduser.loading === 'pending' && <Progress />}
            {addEditCategorySettingReduser.loading === 'failed' && <APIErorr reduser={addEditCategorySettingReduser} />}




            <TextField disabled={addEditCategorySettingReduser.loading === 'pending'} error={showAlertMsg.textName} helperText={categorObject.name === '' && t("MSG5")} onChange={handleChange} value={categorObject.name} name="name" inputProps={{ size: 15, maxLength: "15", required: true }} id="name" sx={{ margin: 1 }} fullWidth label={t("CategoryName")} variant="standard" type="text" />
            <Divider sx={{ margin: 2 }} />

         

            <FormControl disabled={addEditCategorySettingReduser.loading === 'pending'} fullWidth>
                <FormLabel id="demo-row-radio-buttons-group-label">{t("ImageType")}</FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="buttons-group-imageType"
                    value={categorObject.color === 0 ? "image" : "color"}
                    onChange={handleChange}
                >
                    <FormControlLabel value="color" control={<Radio />} label={t("Color")} />
                    <FormControlLabel value="image" control={<Radio />} label={t("Image")} />

                </RadioGroup>
            </FormControl>

            <Box sx={{ width: 150, hidden: 100 }}>




                {getAvatar(categorObject.color, categorObject.name, categorObject.image, false)}
                <ImageDialog control={[openImageDialog, setOpenImageDialog]} data={[categorObject, setCategorObject]} />
                <ColorDialog control={[openColorDialog, setOpenColorDialog]} data={[categorObject, setCategorObject]} />

                <Button
                    disabled={addEditCategorySettingReduser.loading === 'pending'}
                    component="label"
                    onClick={() => setOpenColorDialog(true)}
                    variant="contained" sx={{ padding: "4px", height: "100%", display: categorObject.color === 0 && 'none' }} >{t("SelectColor")}
                </Button>

                <Button
                    disabled={addEditCategorySettingReduser.loading === 'pending'}
                    component="label"
                    variant="contained" sx={{ padding: "4px", height: "100%", display: categorObject.color !== 0 && 'none' }} >
                    {t("UploadImage")}
                    <input
                        type="file"
                        accept="image/png, image/gif, image/jpeg"
                        hidden
                        onChange={onChangePicture}
                        name="contentPath"

                    />

                </Button>




            </Box>
            <Box sx={{ display: setsaveCategoryFun !== null && 'none' }}>

                <Divider sx={{ margin: 2 }} />

                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "end", gap: 1 }}>
                    <Button variant='text' onClick={handelSaveButton}>{t("Save")}</Button>
                    <Button variant='text' onClick={handelCancelButton}>{t("Cancel")}</Button>




                </Box>


            </Box>


        </Box>
    )
}

export default AddEditCategory